const zh = {
  Exercise: {
    Units: "单元",
    Blocks: "模块",
    Exercises: "练习",
    Unit: "单元",
    Block: "模块",
    Exercise: "练习",
    ExerciseCount: "练习{{count}}",
    Script: "视频文本",
    HideScript: "隐藏文本",
    ShowScript: "显示文本",
    LanguageSamples: "语言示例",
    Extras: "附加内容",
    ToolReload: "重新加载",
    ToolTranslate: "翻译",
    TranslateHelper: "在练习中选择文本以翻译，并使用词典进行学习",
    ToolCheck: "检查",
    ToolNext: "下一步",
    IsCheckedWarning: "该任务已检查",
    NotFilledWarning: "您还没回答所问题",
    Translate: "翻译",
    Vocabulary: "词汇",
    NoTranslation: "没有翻译",
    AddToDictionary: "添加到词典",
    SelectedTranslationsWarning: "您需要选择 1-3 个翻译",
    TranslateWordFailed: "单词翻译失败",
    AddWordsFailed: "添加单词失败",
    AddWordsSuccess: "单词已成功添加",
    AddedBefore: "之前已添加",
    EnterText: "在此输入",
    Characters: "字符",
    Words: "单词",
    TextSize: "您的文本量：",
    WordsAtMinimum: "达到最少单词数",
    LearnWords: "学习单词",
    Ok: "确定",
    SendForReview: "发送给教师",
    Expand: "展开",
    Collapse: "收起",
    Close: "关闭",
    ResizeTooltip: "拉伸以便阅读",
    ResetChangesTooltip: "重置所有更改",
    LinkUnavailableTooltip:
      "由于 RKN 的相关措施，链接可能无法使用，我们正在处理",
    NoChange: "没有更改",
    CorrectAnswer: "正确答案",
    MistakesOriginalText: "原文：",
    MistakesUserAnswer: "您的答案：",
    MistakesCorrectAnswer: "正确版本：",
    DevTooltip: "此类练习仍在开发中，若要切换到旧界面，请",
    FollowLink: "点击此链接",
    CreativeExercisePassed: "您的作业已发送给教师",
    CreativeExerciseVerified: "您的作业已检查。点击",
    CreativeExerciseVerifiedLink: "这里",
    DialogExerciseConfirmAnswer: "确认",
    DialogExerciseResetAnswer: "重新录制",
    DialogExerciseSelectAnswer: "这个",
    DialogExerciseHelperLegend: "如何完成练习",
    DialogExerciseFinishHelperLegend: "恭喜！",
    DialogExerciseFirstHelper:
      "请先在下方消息列表中选择您的答案，然后点击麦克风并说出来。",
    DialogExerciseSecondHelper:
      "很好，系统已识别您的语音！请确认答案或重新录制。",
    DialogExerciseThirdHelper:
      "您语音输入尝试次数已用完，请手动选择其中一个答案选项。",
    DialogExerciseFinishHelper:
      "您已完成练习。您可以听完整对话，或点击“检查”按钮进入下一个练习",
    DialogExerciseRecognitionError:
      "很遗憾，系统无法识别您的答案，请再试一次。",
    AudioRecorderText: "点击录音（{{count}} 秒）",
    RadioLineHelperTextLeft: "并非所有正确答案都已给出。请再找出",
    RadioLineHelperTextRight: "个正确答案。",
    NextDisabledWarning: "请先检查练习",
    BrokenError: "该练习仍在开发中，请在旧界面中完成。",
    BrokenErrorLink: "链接",
    SpeakingResultHelper: "很好，系统已识别您的答案",
    GrammarBlockHelper: "语法参考提供三种语言：鞑靼语、俄语和英语。",
    AIAnalyzeTitle: "与 AI 一起分析您的答案",
    AIAnalyzeCTA: "分析",
    AIResponseTitle: "分析结果",
    AILoading: "这可能需要几秒钟",
    CorrectAnswersTitle: "正确答案：",
    CorrectAnswersShowCTA: "显示",
    CorrectAnswersHideCTA: "返回我的答案",
    CorrectAnswersPreviewStatus: "您正在查看正确答案",
  },
  ResultsModals: {
    UnitTitle: "单元结果：",
    BlockTitle: "模块结果",
    Passed: "正确：",
    Wrong: "错误：",
    Skipped: "跳过：",
    Blocks: "模块",
    Block: "模块 {{order}}：{{name}}",
    Exercises: "练习",
    Exercise: "练习 {{order}}：{{name}}",
    Repeat: "重复",
    Continue: "继续",
    DontShowAgain: "不再显示此窗口（您可以在个人资料设置中重新开启）",

    TestUnitTitle: "恭喜！您已完成第 {{order}} 阶段测试",
    TestUnitResultTitle: "您的结果是",
    TestUnit: "单元 {{order}}. {{name}}",
    TestUnitTotalProgress: "总体进度",
    TestUnitResults: "结果",
    TestUnitNext: "开始下一阶段",
    TestUnitScoredPoints_zero: "{{count}}/{{total}} 分",
    TestUnitScoredPoints_one: "{{count}}/{{total}} 分",
    TestUnitScoredPoints_other: "{{count}}/{{total}} 分",

    TestCourseTitle: "恭喜！您已完成测试",
    TestCourseRecomendedLevel: "为您推荐的级别课程是 -",
    TestCourseTotalProgress: "总体进度",
    TestCourseResultProgress: "结果",
    TestCourseShowResults: "查看结果",
    TestCourseShowHourse: "学时数",
    TestCourseHint: "重点发展所有语言技能（口语、听力、阅读和写作）",
    TestCourseA1Long: "我能理解对话的主要意思。我能介绍朋友和家人",
    TestCourseA2Long: "我能理解单个句子，并能谈论日常话题",
    TestCourseB1Long: "我能在大多数情况下使用所有动词时态进行交流",
    TestCourseB2Long: "我能阐述自己的观点、谈判并进行书信往来",
    TestCourseC1Long: "我能流利阅读文学作品并进行演讲",
    TestCourseC2Long: "我能讨论任何话题，水平接近母语者",
    TestCourseA1Short: "初级一",
    TestCourseA2Short: "初级二",
    TestCourseB1Short: "中级一",
    TestCourseB2Short: "中级二",
    TestCourseC1Short: "高级一",
    TestCourseC2Short: "高级二",
    CertificateTitle: "恭喜，您已通过该单元！",
    CertificateSubtitle: "您现在可以获得成功完成课程的证书",
    CertificateDownload: "下载证书",
  },
  TestingCourseResult: {
    ModalTitle: "测试结果",
    Confirm: "查看结果",
    ModalBodyEntrance:
      "亲爱的 {{fullName}}，建议您参加 CEFR 等级课程：{{cefrLevel}}。",
    ModalBodyFinal:
      "亲爱的 {{fullName}}，您已完成测试，得分为 {{courseMark}} / {{maxMark}}。\n您的得分为 {{percentage}}%。",
    ModalBodyDefault: "亲爱的 {{fullName}}，您已成功完成测试。",
  },
};

export default zh;
